import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-vehicle-nav-pill',
    templateUrl: './vehicle-nav-pill.component.html',
    styleUrls: ['./vehicle-nav-pill.component.css'],
    standalone: false
})
export class VehicleNavPillComponent {
  @Input() inventoryId: string = '';

}
